import { render, staticRenderFns } from "./ModalComponent.vue?vue&type=template&id=68743837&scoped=true"
import script from "./ModalComponent.vue?vue&type=script&lang=js"
export * from "./ModalComponent.vue?vue&type=script&lang=js"
import style0 from "./ModalComponent.vue?vue&type=style&index=0&id=68743837&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68743837",
  null
  
)

export default component.exports